import styled from "styled-components";

export const Content = styled.div`
  width: 520px;
  max-width: 100%;
  max-height: 60vh;
  overflow-y: auto;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 36px 20px;
  font-size: 13px;
  color: ${(props) => props.theme.brand.muted};

  .MuiSvgIcon-root {
    color: #b7c3d3;
    font-size: 30px;
  }
`;
